function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import EventEmitter from 'eventemitter3';
import getManager from './getManager';
import setField from '../../utils/setField';
export default class StateManager extends EventEmitter {
  constructor({
    instanceId,
    pathToData
  }) {
    super();
    _defineProperty(this, "instanceId", null);
    _defineProperty(this, "context", null);
    _defineProperty(this, "pathToData", null);
    _defineProperty(this, "initialize", context => {
      if (context) {
        this.context = context;
        context.managers = context.managers || [];
        if (!context.managers.find(instance => instance.instanceId === this.instanceId)) {
          context.managers.push(this);
        } else {
          console.warn(`The manager with id: ${this.instanceId} is already registered to this context`);
        }
        this.initializeState();
      }
    });
    _defineProperty(this, "initializeState", () => {});
    _defineProperty(this, "getSerializableData", () => {
      return {};
    });
    _defineProperty(this, "getSerializedScript", () => '');
    _defineProperty(this, "getHeadScriptContent", () => {
      return `
      window.${this.pathToData} = ${JSON.stringify(this.getSerializableData())};
      ${this.getSerializedScript()}
    `;
    });
    _defineProperty(this, "getHeadScript", () => {
      return `
      <script>
        ${this.getHeadScriptContent()}
      </script>
    `;
    });
    _defineProperty(this, "getRequiredScripts", () => []);
    this.instanceId = instanceId;
    this.pathToData = pathToData;
  }
}
_defineProperty(StateManager, "AppState", 'AppState');
_defineProperty(StateManager, "DataLayer", 'DataLayer');
_defineProperty(StateManager, "getInstance", (Type, context) => {
  if (!context) {
    return null;
  }
  let manager = getManager(Type.InstanceId, context);
  if (!manager) {
    manager = new Type(context);
    manager.initialize(context);
    if (typeof window !== 'undefined') {
      setField(window, `KBB.Blueprint.${Type.InstanceId}`, manager);
    }
  }
  return manager;
});